import {bindCostFieldsToUpdateTotals, initDatePickers} from '../shared/capex-form-fields';

export default function () {
    dropdowns();
    bindCostFieldsToUpdateTotals();
    initDatePickers();
}

const dropdowns = () => {
    const k_otherDetails = $('[name="EquipmentType"]').data('kendoDropDownList');
    if (k_otherDetails) k_otherDetails.bind('change', showHideOtherDetails);

    const k_vehicleDisposition = $('[name="VehicleDisposition"]').data('kendoDropDownList');
    if (k_vehicleDisposition) k_vehicleDisposition.bind('change', disableDriverInformation);
}

const showHideOtherDetails = (object) => {
}

const disableDriverInformation = (object) => {
    let enabled = object.sender.value() !== "1";
    $('#DriverInformation input').attr('disabled', !enabled);
    $('#DriverInformation select').data('kendoDropDownList').enable(enabled);
}
